export default "__VITE_ASSET__DOwGSReQ__"